/* istanbul ignore file */
import React from "react";
import Circle from "@digital-hig/icon/lib/esm/icons/circle";
import CircleFull from "@digital-hig/icon/lib/esm/icons/circle-full";
import SvgIcon from "@mui/material/SvgIcon";
var CheckedIcon = function CheckedIcon() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SvgIcon, null, /*#__PURE__*/React.createElement(Circle, null)), /*#__PURE__*/React.createElement(SvgIcon, {
    className: "DhigRadio--icon--inner"
  }, /*#__PURE__*/React.createElement(CircleFull, null)));
};
export var makeRadioStyles = function makeRadioStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiRadio: {
      defaultProps: {
        checkedIcon: /*#__PURE__*/React.createElement(CheckedIcon, null),
        icon: /*#__PURE__*/React.createElement(SvgIcon, null, /*#__PURE__*/React.createElement(Circle, null))
      },
      styleOverrides: {
        root: {
          fontSize: "inherit",
          padding: primitives.spacings["0"],
          margin: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["0"]),
          borderRadius: primitives.borderRadii.round,
          "&:hover": {
            outline: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-hover"]),
            outlineOffset: "-1px"
          },
          "&:focus, &.Mui-focusVisible": {
            outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["ink-focus"])
          },
          "&:active": {
            outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["fill-success"]),
            outlineOffset: "-1px"
          },
          '& + [class*="MuiFormControlLabel-label"]': {
            color: tokens.colors["ink-on-background"],
            paddingLeft: primitives.spacings["3"],
            fontSize: primitives.fontSizes["3"],
            lineHeight: primitives.lineHeights.compact
          },
          '& [class*="MuiSvgIcon-root"]': {
            width: primitives.spacings["5"],
            height: primitives.spacings["5"],
            color: tokens.colors["ink-on-background"]
          },
          "& .DhigRadio--icon--inner": {
            width: "10px",
            height: "10px",
            position: "absolute"
          },
          '&[class*="MuiRadio-colorSecondary"]:hover, &[class*="MuiRadio-colorSecondary"].Mui-checked:hover': {
            backgroundColor: tokens.colors.background
          }
        }
      }
    }
  };
};